module.exports = __webpack_public_path__ + "img/HeaderLogo.e73c88a5.png";